import { render, staticRenderFns } from "./other-sources.vue?vue&type=template&id=044b85e2&"
import script from "./other-sources.vue?vue&type=script&lang=js&"
export * from "./other-sources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports